var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.243,
    height: 19.109,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1802",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.251 10.75c.829 0 1.501.672 1.501 1.501v4.606a1.501 1.501 0 1 1-3.002 0v-4.606c0-.829.672-1.501 1.501-1.501m0-.75A2.254 2.254 0 0 0 0 12.251v4.606a2.254 2.254 0 0 0 2.251 2.252 2.254 2.254 0 0 0 2.251-2.252v-4.606A2.254 2.254 0 0 0 2.251 10",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.251 17.6a1.202 1.202 0 0 1-1.202-1.202v-1.687a1.202 1.202 0 1 1 2.404 0v1.687c0 .664-.538 1.202-1.202 1.202",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.515 15.33a1.202 1.202 0 0 1-1.202-1.202v-1.687a1.202 1.202 0 1 1 2.404 0v1.687c0 .664-.538 1.202-1.202 1.202",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.779 12.117a1.202 1.202 0 0 1-1.202-1.202V9.228a1.202 1.202 0 1 1 2.404 0v1.687c0 .664-.538 1.202-1.202 1.202",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.042 7.421a1.202 1.202 0 0 1-1.202-1.202V4.532a1.202 1.202 0 1 1 2.404 0v1.687c0 .664-.538 1.202-1.202 1.202",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.491 6.75c.829 0 1.501.672 1.501 1.501v8.606a1.501 1.501 0 1 1-3.002 0V8.251c0-.829.672-1.501 1.501-1.501m0-.75A2.254 2.254 0 0 0 5.24 8.251v8.606a2.254 2.254 0 0 0 2.251 2.252 2.254 2.254 0 0 0 2.251-2.252V8.251A2.254 2.254 0 0 0 7.491 6",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.731 2.75c.829 0 1.501.672 1.501 1.501v12.606a1.501 1.501 0 1 1-3.002 0V4.251c0-.829.672-1.501 1.501-1.501m0-.75a2.254 2.254 0 0 0-2.251 2.251v12.606a2.254 2.254 0 0 0 2.251 2.252 2.254 2.254 0 0 0 2.251-2.252V4.251A2.254 2.254 0 0 0 12.731 2",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.992.75c.829 0 1.501.672 1.501 1.501v14.606a1.501 1.501 0 1 1-3.002 0V2.251c0-.829.672-1.501 1.501-1.501m0-.75a2.254 2.254 0 0 0-2.251 2.251v14.606a2.254 2.254 0 0 0 2.251 2.252 2.254 2.254 0 0 0 2.251-2.252V2.251A2.254 2.254 0 0 0 17.992 0",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.243v19.109H0V0z",
    "data-name": "Rectangle 1497"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompta);
export default __webpack_public_path__ + "static/media/compta.7f0161801c90bbdf91f8e0af05e0f623.svg";
export { ForwardRef as ReactComponent };